import { environment } from '@pt-env/environment';

export const apiUrls = {
  // Frontend config
  getFrontendConfig: () => `${environment.apiUrl}/api/v1/FrontendConfig`
};
